import globalStore from '$$globalStore';
import constants from '$$helpers/constants';
import ganttViewModel from '$$ganttViewModel';
import calculateActualCostChildTask from './calculateActualCostChildTask';
import rights from '../rights';

export default function (task) {
  let ganttId = task.gantt_id;

  if (task.type === constants.TASK_TYPES.button) {
    return '';
  }

  if (!ganttId && !ganttViewModel.isMultiview()) {
    return '';
  }

  if (!ganttId) {
    ganttId = globalStore.getters['tasksModel/getTask'](task.id)?.gantt_id;
  }

  let resultCost = '';

  if (task.type === constants.TASK_TYPES.project) {
    let totalCost = calculateActualCostChildTask(task);
    const children = globalStore.getters['tasksModel/getAllChildByTask'](ganttId, task.id);

    children.forEach(childTask => {
      if (childTask.type !== constants.TASK_TYPES.button) {
        totalCost += calculateActualCostChildTask(childTask);
      }
    });

    resultCost = totalCost;
  } else {
    resultCost = calculateActualCostChildTask(task);
  }

  if (!rights.project.hasCostRight(task.gantt_id)) return '';

  return resultCost;
}
